import { KEYBOARD } from "constants/gallery";
import { useEffect } from "react";

export const useIsVisible = (ref, callback, otherDependencies) => {
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        if (callback) callback(ref);
      }
    });

    if (ref.current) observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, otherDependencies]);
};

export const useEnterKeyAction = () => {
  useEffect(() => {
    function handleEnterKey(event) {
      if (event.key === KEYBOARD.ENTER.STR) {
        const activeElement = document.activeElement;

        if (activeElement) {
          event.preventDefault();
          event.stopPropagation();

          if (typeof activeElement.click === "function") {
            activeElement.click();
          } else if (
            activeElement.tagName === "SVG" ||
            activeElement.closest("svg") ||
            activeElement.tagName === "SPAN"
          ) {
            activeElement.dispatchEvent(
              new MouseEvent("click", { bubbles: true })
            );
          } else {
            activeElement.dispatchEvent(
              new Event("enterPress", { bubbles: true })
            );
          }
        }
      }
    }

    document.addEventListener("keydown", handleEnterKey);
    return () => {
      document.removeEventListener("keydown", handleEnterKey);
    };
  }, []);
};
